import { render, staticRenderFns } from "./WsCRUDFilter.vue?vue&type=template&id=a39a7f9c&"
import script from "./WsCRUDFilter.vue?vue&type=script&lang=js&"
export * from "./WsCRUDFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports